export const addCategoryValidate = addCategoryData => {

    const errors = {}

    if (!addCategoryData.categoryName.trim()) {
        errors.categoryName = "لطفا نام دسته بندی را وارد کنید"
    } else {
        delete errors.categoryName
    }

    if (!addCategoryData.slug.trim()) {
        errors.slug = "لطفا نام دسته بندی به انگلیسی را وارد کنید"
    } else {
        delete errors.slug
    }

    return errors;
}